<template>
    <CRow>
        <CCol col>
            <div style="width:100%; height: 80vh;">
                <ejs-grid ref='grid' :dataSource="groupData" :allowFiltering='true' :commandClick='commandClick' :allowPaging="true" 
                          :allowResizing='true' :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true'
                          :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' 
                          :actionComplete='actionComplete' :actionBegin="actionBegin" :actionFailure="actionFailure" :filterSettings='filterOptions' :enablePersistence ="true"
                          :query='query' :toolbarClick='toolbarClick' width="100%" height="100%" :queryCellInfo='queryCellInfo'>
                    <e-columns>
                        <e-column type='checkbox' width='50'></e-column>
                        <e-column field='id' headerText='Id' :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='lastRunDate' headerText='Run on' :validationRules="requiredRules" :format='dateFormatOptions' type='date'></e-column>
                        <e-column field='name' headerText='Report Name' width=300 :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='type' headerText='Type' :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='createdBy' headerText='Created By' :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='clientName' headerText='Client/ATG Name' :validationRules="requiredRules" type="string"></e-column>
                        <e-column field='contractName' headerText='Contract Name' width='320' :validationRules="requiredRules" type="string"></e-column>
                        <e-column headerText='Actions' width='150' textAlign='Center' :template='cTemplate'></e-column>
                    </e-columns>
                </ejs-grid>
               </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn } from "@syncfusion/ej2-vue-grids";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { Query } from '@syncfusion/ej2-data';
    import SyncHelper from '../../common/syncfusion';
    import gridOptions from '../../common/gridOptions'
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import Router from 'vue-router'
    import store from '../../store';
    import router from '../../router';
    import apis from '../../common/network'
    import urls from '../../common/urls'
    import moment from 'moment';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

    Vue.use(Router)
    Vue.use(ButtonPlugin);
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);

    Vue.use(GridPlugin);

    export default {
        name: 'groupsAndPermissionsForm',
        components: {
        },
        data() {
            return {
                query: new Query().addParams("latest", "true"),
                store: store,
                router: router,
                groupData: SyncHelper.getDataManager("ReportTemplate"),
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy hh:mm a' },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: false,
                    allowAdding: false,
                    allowDeleting: false,
                    mode: 'Dialog'
                }, 
                toolbar: ['ExcelExport', { text: 'Download Selected', tooltipText: 'Download checked reports in zip file', prefixIcon: 'e-description', id: 'DownloadSelected' }],
                requiredRules: { required: true, maxLength: 256 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings,
                commands: [{ buttonOption: { cssClass: 'e-primary', content: 'Export' } }],
                cTemplate: function () {
                    return {
                        template: Vue.component('columnTemplate', {
                            template: `<ejs-button cssClass='secondary' v-on:click.native="click(data)">Download</ejs-button>`,// <a :href="this.data.reportUrl" cssClass='e-block e-success'   download> Download</a>
                            data: function () {
                                return { 
                                    data: {}
                                }
                            },
                            methods: {
                                click: function (args) {
                                    
                                    showSpinner(document.getElementById('mainSpinner'));
                                    apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/getReportUri/${args.id}`,
                                        { responseType: 'blob' }).then(
                                            it => {
                                                var blob = new Blob([it.data], { type: 'application/' + it.headers['content-type'] })
                                                var downloadElement = document.createElement('a')
                                                var href = window.URL.createObjectURL(blob) // Create a downloaded link
                                                downloadElement.href = href
                                                downloadElement.download = args.name + "-" + moment().format('DD/MM/YYYY HH:mm') + ".xlsx"; // filename after download
                                                document.body.appendChild(downloadElement)
                                                downloadElement.click() // Click to download
                                                document.body.removeChild(downloadElement)
                                                hideSpinner(document.getElementById('mainSpinner'));
                                            }).catch(
                                                response => {
                                                    var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                                    gridOptions.errorAlert("Error: " + message);
                                                    hideSpinner(document.getElementById('mainSpinner'));
                                                }
                                            );
                                }
                            }
                        })
                    }
                }
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading',

            });
        },
        methods: {
            commandClick: function (args) {
                var templateId = args.rowData.id;
                if (args.commandColumn.buttonOption.content == "Export") {
                    this.runReport(templateId, this.$refs.grid);
                    hideSpinner(document.getElementById('mainSpinner'));
                }
            },
            toolbarClick(args) {
                if (args.item.properties.id === 'DownloadSelected') {
                    var a = this.$refs.grid.getSelectedRows()
                   var ids= this.$refs.grid.getSelectedRecords().map((e) => e['id']);

                    showSpinner(document.getElementById('mainSpinner'));
                    apis.protectedApi.post(`${urls.apiBaseUrl}ReportTemplate/downloadZip/`, ids,
                        { responseType: 'blob' }).then(
                            it => {
                                var blob = new Blob([it.data], { type: 'application/' + it.headers['content-type'] })
                                var downloadElement = document.createElement('a')
                                var href = window.URL.createObjectURL(blob) // Create a downloaded link
                                downloadElement.href = href
                                downloadElement.download =  "MultiReportDownload-" + moment().format('DD/MM/YYYY HH:mm') + ".zip"; // filename after download
                                document.body.appendChild(downloadElement)
                                downloadElement.click() // Click to download
                                document.body.removeChild(downloadElement)
                                hideSpinner(document.getElementById('mainSpinner'));
                            }).catch(
                                response => {
                                    var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                                    gridOptions.errorAlert("Error: " + message);
                                    hideSpinner(document.getElementById('mainSpinner'));
                                }
                            );
                }

                if (args.item.properties.text === 'Excel Export') {
                    gridOptions.excelExport(args, "Available Reports.xlsx", this.$refs);
                }
                
            },
            excelExportComplete(args) {
             
                this.$refs.grid.hideSpinner();
                hideSpinner(document.getElementById('mainSpinner'));
            },

            actionComplete(args) {
               gridOptions.actionComplete(args, this.$refs);
            },
            actionBegin(args) {
               
                gridOptions.actionBegin(args);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
            },
            queryCellInfo(args) {
                if (args.column.field === 'lastRunDate') {
                    if (args.data['lastRunDate']) {
                        args.cell.textContent = this.fixDateOffset(args.data['lastRunDate']);
                    }
                } 
            },
            fixDateOffset: function(date) {
                date.setHours(date.getHours() - (date.getTimezoneOffset() / 60));
                return moment(date).format('DD/MM/YYYY hh:mm A');
            },
        }, 
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn]
        }
    };

</script>
<style>
</style>
